import { useEffect } from "react";
import { createPortal } from "react-dom";
import { Outlet, useNavigate } from "react-router-dom";

import "../profile/profile.styles.scss";

export default function SocialRouteLayer() {
  const navigate = useNavigate();

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const closeOnEscape = (event) => {
      if (event.key === "Escape") navigate(-1);
    };

    window.addEventListener("keydown", closeOnEscape);

    return () => {
      window.removeEventListener("keydown", closeOnEscape);
      document.body.style.overflow = previousOverflow;
    };
  }, [navigate]);

  return createPortal(
    <div
      className="social-route-layer"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) navigate(-1);
      }}
    >
      <Outlet />
    </div>,
    document.body,
  );
}
